import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Chip, Divider, Modal, TrendingUpIcon, WhatsAppIcon, PinterestIcon, ContentCopyIcon, ShoppingCartIcon, AutoAwesomeIcon } from "../utils/mui-imports";
import { useLocation, useNavigate } from 'react-router-dom';

import Caption from "./Caption";
import CTANewUI from "./CTANewUI";
import SaveLookButton from "./SaveLookButton";
import { useAuth } from "../context/AuthContext";
import { getGuestId } from "../utils/guest";
import ShareLookButtons from "./ShareLookButtons";

const ShowcaseLookCard = ({title, caption, image, lid, avatarId = null, isAvatar = false}) => {


    const {user} = useAuth()
    const [guestId, setGuestId] = useState(null);
    //const [avatarId, setAvatarId] = useState(avatarId);
    //const [isAvatar, setIsAvatar] = useState(isAvatar);

    

     useEffect(() => {
        console.log('user - ', user)
        async function checkGuest() {
          if (!user) {
            const guestId = await getGuestId();
            setGuestId(guestId)
         
          } else {
            console.log("user - ", user)
          }
       
        }
    
        checkGuest();
       
      }, [user]);
    

    console.log("user - ", user)

    const location = useLocation()
    const navigate = useNavigate()
     const handleShopTheLook = () => {
       navigate("/shop-the-look", { state: { 
         imageUrl: image, 
         showAIImage:false,
         attributes: null, 
         title: title, 
         caption: caption,
        lid:lid
        } });
     };
 
 
   return (
   <>
         <Box sx={{
           display:'flex',
           flexDirection:'column',
           justifyContent:'top',
           // height:'90vh', 
           // p: 4,
           overflowY:'scroll',
           gap:0.5,
           backgroundColor: 'white',
           position: 'relative',  }}>
         
             <>
                 <img
                 
                 src={image} alt={title} style={{ 
                  width: '100%',
                  height: 'auto',
                  borderBottomLeftRadius:16,
                  borderBottomRightRadius:16,
                  maxHeight:'30vh',
                  objectFit:'contain'
                   }} />
                 
                 
                 <Box
                 px={1.5}
                 pt={1}
                 // gap={2}
                 sx={{
                   display:'flex',
                   flexDirection:'column',
                   gap:1
                 }}
                 >
               <Typography align='center' color="black" variant="h1" fontSize={'1.5rem'} fontWeight={'bold'}>{title}</Typography>
 
               <Box
               sx={{
                 display:'flex',
                 gap:2,
                 justifyContent:'center'
               }}
               >
 
                
                
                  <Chip
                 // color='primary'
                 size='small'
                 // icon={</>}
                 sx={{
                   fontWeight:'bold'
                 }}
                 label={'Created by Anonymous'}
                 />
                   <Chip
                   size="small"
                //  color='secondary'
                 icon={<TrendingUpIcon/>}
                 sx={{
                   fontWeight:'bold'
                 }}
                 label={'Trending'}
                 />
 
               </Box>
             
               {/* <Typography>{caption}</Typography> */}
               <Box
               px={2}
               >
               <Caption caption={caption} align={'center'} numberOfLines={1}/>
               </Box>

               <Box sx={{
                 pt:1,
                 gap:2,
                 display: "flex", flexDirection: "row", justifyContent: "right", alignItems: 'center' }}>
 
                <ShareLookButtons 
                  image={image} 
                  lookId={lid} 
                  avatarId={avatarId}
                  isAvatar={isAvatar}
                  />
                {/* <Box sx={{
                 px:1,
                 // backgroundColor:'rgba(1,1,1,0.1)',
                 width:'auto',
                 display: "flex", flexDirection: "row", justifyContent: "center", alignItems: 'center' }}>
                 <Typography fontWeight={"bold"} fontSize={'0.75rem'}>Share</Typography>
                 <Button
                 
                   sx={{ color: "black", "&:hover": { transform: "scale(1.1)" }, transition: "transform 0.2s ease-in-out" }}
                   // onClick={() => handleShare("whatsapp")}
                 >
                   <WhatsAppIcon fontSize="small" />
                 </Button>
                 <Button
                   sx={{ color: "black", "&:hover": { transform: "scale(1.1)" }, transition: "transform 0.2s ease-in-out" }}
                   // onClick={() => handleShare("pinterest")}
                 >
                   <PinterestIcon fontSize="small" />
                 </Button>
                 <Button
                   sx={{ color: "black", "&:hover": { transform: "scale(1.1)" }, transition: "transform 0.2s ease-in-out" }}
                   // onClick={() => handleShare("copy")}
                 >
                   <ContentCopyIcon fontSize="small" />
                 </Button>
               </Box> */}
 
                <Divider orientation="vertical" flexItem />

              <SaveLookButton
              lid={lid}
              uid={user? user.uid: null}
              isUser={user? true:false}
              location={location.pathname}
              saveStatus={user? null : false}
              guestId={user? null:guestId}
              />
              
 
               </Box>

               <Button
           color="primary"
           sx={{
             backdropFilter: 'blur(5px)',
             borderRadius: 2,
             backgroundColor: 'rgba(1,1,1,0.85)',
             my:1,
             // border: '2px solid black',
           }}
           // onClick={()=>{navigate(`shop-the-look`)}}
           onClick={()=>{handleShopTheLook()}}
           startIcon={<ShoppingCartIcon color='white' sx={{
             color:'white'
           }}/>}
           fullWidth
           variant="text"
         >
           
           <Typography
             textTransform={'capitalize'}
             fontWeight={'bold'}
             variant="body1"
             color="white"
             fontSize={'1rem'}
             p={1}
 
           >
             Shop This Look
           </Typography>
 
           
         </Button>

         {/* <Divider/> */}

         <Button
           color="primary"
           sx={{
            backgroundImage: "linear-gradient(to right, #e01cd5, #1CB5E0)",
             backdropFilter: 'blur(5px)',
             borderRadius: 2,
             backgroundColor: 'rgba(1,1,1,0.75)',
             my:0.25,
             // border: '2px solid black',
           }}
           // onClick={()=>{navigate(`shop-the-look`)}}
           onClick={()=>{navigate(`/remix/${lid}`)}}
           startIcon={<AutoAwesomeIcon sx={{color:'white'}} />}
          //  fullWidth
           variant="text"
         >
           
           <Typography
             textTransform={'capitalize'}
             fontWeight={'bold'}
             variant="body1"
             color="white"
             fontSize={'0.75rem'}
             p={0.5}
 
           >
             Remix This Look
           </Typography>
 
           
         </Button>
 
            
 
 
           
 
          


           <CTANewUI
                 
                 heading={'Explore Trending Looks.'}
                 destination={'/browse'}
                 buttonText={"Browse More Looks"}
                 
                 />
  
               
               </Box>
            
            
             </>
         
         </Box>
        
   
   </>
   );
 };


 export default ShowcaseLookCard;